interface LangTextInter {
    product_name: string;
    tab_product: string;
    tab_bundles?: string;
    tab_support: string;
    tab_specs: string;
    btn_buy: string;
    btn_subscribe?: string;
}
export const LangText: Record<'us' | 'jp' | 'eu' | 'uk' | 'de' | 'fr' | 'es' | 'it' | 'ca' | 'nl', LangTextInter> = {
    us: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_subscribe: 'Subscribe',
        btn_buy: 'Buy Now',
    },
    ca: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_subscribe: 'Subscribe',
        btn_buy: 'Shop Now',
    },
    jp: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: '概要',
        tab_bundles: 'セット購入',
        tab_support: 'サポート',
        tab_specs: '仕様',
        btn_buy: '今すぐ購入',
    },
    eu: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
        btn_subscribe: 'Subscribe',
    },
    nl: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_support: 'Ondersteuning',
        tab_specs: 'Specificaties',
        btn_buy: 'Shop nu',
        btn_subscribe: 'Abonneren',
    },
    uk: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
        btn_subscribe: 'Subscribe',
    },
    de: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Produkt',
        tab_support: 'Support',
        tab_specs: 'Technische Daten',
        btn_buy: 'Jetzt shoppen',
        btn_subscribe: 'Abonnieren',
    },
    fr: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Product',
        tab_support: 'Assistance',
        tab_specs: 'Spécifications',
        btn_buy: 'Acheter',
        btn_subscribe: 'S’abonner',
    },
    es: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Producto',
        tab_support: 'Asistencia',
        tab_specs: 'Especificaciones',
        btn_buy: 'Comprar ahora',
        btn_subscribe: 'Suscribirse',
    },
    it: {
        product_name: 'EcoFlow GLACIER Classic',
        tab_product: 'Prodotto',
        tab_support: 'Assistenza',
        tab_specs: 'Specifiche',
        btn_buy: 'Acquista ora',
        btn_subscribe: 'Iscriviti',
    },
};
